(function () {
  window.ga = window.ga || function() {};
  window.MF = window.MF || {};

  var currentHash;
  var openFlexPopup = false;


  //The flex app calls this global obj
  window.MF.getBaseUrl = function () {
    return mfConfig.BasePath;
  };

  window.MF.setAppLoadPercent = function (percent) {
    mfConfig.appLoadPercent = percent;
  };
  window.MF.getPathNames = function () {
    return currentHash;
  };

  window.MF.setTitle = function (title) {
    return window.document.title = title;
  };

  window.MF.setValue = function (value) {
    if (MF.flexAngularProxy) {
      MF.flexAngularProxy.changeUrl('/' + value);
    } else {
      if (BrowserDetect.browser == "Explorer" && BrowserDetect.version == 10) {
        window.location.hash = window.location.hash; // Fix for IE10
      }
      return window.location.hash = '#/' + value;
    }
  };

  window.MF.loadAppSwf = loadAppSwf;
  window.MF.getFlexApp = getFlexApp;
  window.MF.changeUrlHash = changeUrlHash;
  window.MF.getSessionKey = function () {
    return mfConfig.sessionId;
  };
  window.MF.getSwfMarketingUrl = function () {
    return mfConfig.SwfMarketingUrl;
  };
  window.MF.openPreview = openPreview;
  window.MF.openTourVideoFromFlex = openTourVideoFromFlex;
  window.MF.flexOnBeforeUnload = flexOnBeforeUnload;
  window.MF.getBrowser = getBrowser;
  window.MF.getBrowserVersion = getBrowserVersion;
  window.MF.getUseGroupRestrictions = function () {
    return mfConfig.useGroupRestrictions
  };
  window.MF.setOpenFlexPopup = function () {
    openFlexPopup = true;
  };
  window.MF.getOpenFlexPopup = function () {
    var result = !!openFlexPopup;
    openFlexPopup = false;
    return result;
  };


  function changeUrlHash(hash) {
    try {
      hash = hash || window.location.hash;
      currentHash = hash.replace(/^[#|/]+/, '');
      var app = getFlexApp();
      if (app && app.onUrlChange) {
        app.onUrlChange();
      }
    } catch (ex) {
      console.log('FAILED to set flex url. Twiddle our thumbs for awhile and then try again.', ex);
      setTimeout(function () {
        changeUrlHash(hash);
      }, 1000);
    }
  }

  changeUrlHash();

  function flexOnBeforeUnload() {
    if (mfConfig.isUploading) {
      return "Do you want to leave current upload?\n\rYour file will be canceled.";
    }
    var flexApp = MF.getFlexApp();
    if (flexApp && flexApp.checkForUnsavedData) {
      var warning = flexApp.checkForUnsavedData();
      if (warning != "") {
        return warning;
      }
    }
  }


  function getFlexApp() {
    return swfobject.getObjectById(mfConfig.AppName);
  }

  function runLoader() {
    swfobject.embedSWF(
      mfConfig.SwfUrl, //swfUrl
      'content', //id
      "100%", "100%", //width, height
      mfConfig.MinimumFlashVersionRequired, //version
      'expressInstall.swf', //expressInstallSwfUrl
      mfConfig.FlashVars, //flashvars
      {                                 //params
        movie: mfConfig.SwfUrl,
        quality: 'high',
        bgcolor: mfConfig.BackgroundColor,
        allowScriptAccess: 'always',
        allowFullScreen: 'true',
        base: mfConfig.BasePath
      },
      {                                 //attribs
        id: mfConfig.AppName,
        name: mfConfig.AppName,
        align: 'middle',
        width: '100%',
        height: '100%'
      },
      loadApp                              //callback
    );
  }

  var appStarted = false;

  function loadAppSwf() {
    // See if we should abort here? (ie. preloading, etc)
    if (typeof window.mfConfig == 'undefined' || !mfConfig || !mfConfig.SwfUrl || appStarted)
      return;


    appStarted = true;
    trackPageView(mfConfig.AppName + '/start-embedSWF');

    if (browserNeedsFlashUpgrade()) {
      logFirstTimeVisit("noflash");
      showFlashInstaller();
    } else {
      runLoader();
    }
  }

  function logFirstTimeVisit(type) {
    if (mfConfig.isFirstVisit) {
      var logAction = type == "noflash" ? "GetStartedNoFlash" : "GetStartedIOSDevice";
      $.post("/ActionLogs.aspx/LogGetStartedAction", { action: logAction, product: "TMS" });
    }
  }

  function loadApp(loadInfo) {
    if (weHadAnErrorLoadingFlash(loadInfo)) {
      showFlashInstaller();
      trackFlashFailure();
      writeFlashErrorToLog(loadInfo);
    } else {
      trackPageView();
      loadedCallback();
    }
  }

  function loadedCallback() {
    mfConfig.appLoadingStarted = true;
  }

  function weHadAnErrorLoadingFlash(loadInfo) {
    if (!loadInfo)
      mfConfig.StartFailure = true;
    else if (loadInfo.success == false)
      mfConfig.StartFailure = true;
    else
      mfConfig.StartFailure = false;

    return mfConfig.StartFailure;
  }

  function trackFlashFailure() {
    trackPageView(mfConfig.AppName + '/flash-failed-to-start');
  }

  function trackPageView(page) {
    ga('send', 'pageview', page);
    // add any Track.aspx calls we can do here?
  }

  function writeFlashErrorToLog(loadInfo) {
    if (console && console.log) {
      console.log('tracking flash load failure', loadInfo);
    }
  }

  function browserNeedsFlashUpgrade() {
    return !swfobject.hasFlashPlayerVersion(mfConfig.MinimumFlashVersionRequired);
  }

  function showFlashInstaller() {
    document.getElementById(mfConfig.NoFlashID).style.display = "block";
  }

  window.previewWindow = null;

  function openPreview(url) {
    if (window.previewWindow && !window.previewWindow.closed) {
      window.previewWindow.location.href = 'about:blank';
      var cmd = 'window.previewWindow.location.href = "' + url + '"';
      setTimeout(cmd, 250);
    } else {
      if (url == '') url = 'about:blank';
      var w = (window.innerWidth >= 1024) ? window.innerWidth : screen.width;
      var h = (window.innerHeight >= 768) ? window.innerHeight : screen.height;
      var l = (screen.width - w) / 2;
      var t = (screen.height - h) / 2;
//      window.previewWindow = window.open(url, 'previewWindow','scrollbars=auto,resizable=yes,width=' + w + ',height=' + h + ',top=' + t + ',left=' + l + '\'');

      window.previewWindow = window.open(url, 'previewWindow', getWindowOpenParameters(1024, 768));
    }

    if (previewWindow) {
      previewWindow.focus();
    }
  }

  window.tourVideoWindow = null;
  function openTourVideoFromFlex(url, popupWidth, popupHeight) {
    if (tourVideoWindow && !tourVideoWindow.closed) {
      tourVideoWindow.focus();
      return;
    }

    var popUpleft = (screen.width - popupWidth) / 2;
    var popUptop = (screen.height - popupHeight) / 2;

    tourVideoWindow = window.open(url, 'tourVideoWindow', 'scrollbars=auto,location=no,directories=no,resizable=no,width=' + popupWidth + ',height=' + popupHeight + ',left=' + popUpleft + ',top=' + popUptop + '\'');
    tourVideoWindow.focus();
  }


  function getWindowOpenParameters(minW, minH) {
    var params = ['scrollbars=yes', 'resizable=yes'];

    // for smaller screens lets take up the whole area
    if (screen.width < minW || screen.height < minH) {
      params.push('width=' + screen.width);
      params.push('height=' + screen.height);
      params.push('left=0');
      params.push('top=0');
      return params.join(',');
    }

    var w = Math.max(window.innerWidth, minW);
    var h = Math.max(window.innerHeight, minH);
    var l = ((screen.width - w) / 2) || 0;
    var t = ((screen.height - h) / 2) || 0;

    params.push('width=' + w);
    params.push('height=' + h);
    params.push('left=' + l);
    params.push('top=' + t);

    return params.join(',');
  }

  function getBrowser() {
    return BrowserDetect.browser;
  }

  function getBrowserVersion() {
    return BrowserDetect.version;
  }

  function iOSDevice() {
    return BrowserDetect.OS == "iPhone/iPod" ||
      BrowserDetect.OS == "iPad";
  }

//Over 100 lines of crap just to detect iOS?! RAGE!
// No we need this to support our jquery version with crocodoc
// BrowserDectect
  var BrowserDetect = {
    init: function () {
      this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
      this.version = this.searchVersion(navigator.userAgent)
        || this.searchVersion(navigator.appVersion)
        || "an unknown version";
      this.OS = this.searchString(this.dataOS) || "an unknown OS";
    },
    searchString: function (data) {
      for (var i = 0; i < data.length; i++) {
        var dataString = data[i].string;
        var dataProp = data[i].prop;
        this.versionSearchString = data[i].versionSearch || data[i].identity;
        if (dataString) {
          if (dataString.indexOf(data[i].subString) != -1)
            return data[i].identity;
        }
        else if (dataProp)
          return data[i].identity;
      }
    },
    searchVersion: function (dataString) {
      var index = dataString.indexOf(this.versionSearchString);
      if (index == -1) return;
      return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
    },
    dataBrowser: [
      {
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
      },
      {
        string: navigator.userAgent,
        subString: "OmniWeb",
        versionSearch: "OmniWeb/",
        identity: "OmniWeb"
      },
      {
        string: navigator.vendor,
        subString: "Apple",
        identity: "Safari",
        versionSearch: "Version"
      },
      {
        prop: window.opera,
        identity: "Opera",
        versionSearch: "Version"
      },
      {
        string: navigator.vendor,
        subString: "iCab",
        identity: "iCab"
      },
      {
        string: navigator.vendor,
        subString: "KDE",
        identity: "Konqueror"
      },
      {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
      },
      {
        string: navigator.vendor,
        subString: "Camino",
        identity: "Camino"
      },
      {      // for newer Netscapes (6+)
        string: navigator.userAgent,
        subString: "Netscape",
        identity: "Netscape"
      },
      {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer",
        versionSearch: "MSIE"
      },
      {
        string: navigator.userAgent,
        subString: "Gecko",
        identity: "Mozilla",
        versionSearch: "rv"
      },
      {       // for older Netscapes (4-)
        string: navigator.userAgent,
        subString: "Mozilla",
        identity: "Netscape",
        versionSearch: "Mozilla"
      }
    ],
    dataOS: [
      {
        string: navigator.platform,
        subString: "Win",
        identity: "Windows"
      },
      {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac"
      },
      {
        string: navigator.platform,
        subString: "iPad",
        identity: "iPad"
      },
      {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone/iPod"
      },
      {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux"
      }
    ]

  };
  BrowserDetect.init();
})();
